export default __webpack_public_path__ + "static/media/istanbul.1d288b21.png";